<template>
    <div class="min-h-screen flex items-center justify-center bg-gray-100 dark:bg-gray-900 py-12 px-4 sm:px-6 lg:px-8">
        <div class="max-w-md w-full">
            <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-sm px-8 py-10">
                <div class="text-center mb-8">
                    <h1 class="text-4xl font-bold text-blue-600 dark:text-blue-400 mb-6">
                        TwoFiveNine.Club
                    </h1>
                    <h3 class="text-3xl font-semibold text-gray-800 dark:text-gray-100 mb-2">
                        Sign in
                    </h3>
                </div>

                <form @submit.prevent="handleLogin" class="space-y-6">
                    <div v-if="authStore.error" class="p-3 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-md">
                        <p class="text-sm text-red-600 dark:text-red-400">{{ authStore.error }}</p>
                    </div>

                    <div>
                        <label for="username" class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                            Username
                        </label>
                        <input
                            id="username"
                            v-model="username"
                            type="text"
                            required
                            class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-colors bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100"
                            placeholder="Enter your username"
                            :disabled="authStore.isLoading"
                        />
                    </div>

                    <div>
                        <label for="password" class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                            Password
                        </label>
                        <input
                            id="password"
                            v-model="password"
                            type="password"
                            required
                            class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-colors bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100"
                            placeholder="Enter your password"
                            :disabled="authStore.isLoading"
                        />
                    </div>

                    <div>
                        <button
                            type="submit"
                            :disabled="authStore.isLoading || !username || !password"
                            class="w-full bg-blue-600 hover:bg-blue-700 dark:bg-blue-500 dark:hover:bg-blue-600 text-white py-3 px-4 rounded-lg font-medium focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 dark:focus:ring-offset-gray-800 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                        >
                            <span v-if="authStore.isLoading">Signing in...</span>
                            <span v-else>Sign in</span>
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const authStore = useAuthStore()
const router = useRouter()

const username = ref('')
const password = ref('')

const handleLogin = async () => {
    authStore.clearError()
    
    const success = await authStore.login(username.value, password.value)
    
    if (success) {
        router.push('/')
    }
}

onMounted(() => {
    authStore.clearError()
})
</script>
